import React from 'react';

const DataTableFooter = ({
  dataT = [],
  currentPage = 1,
  itemsPerPage,
  handleNextPage,
  handlePreviousPage,
  totalRecords,
}) => {
  const total = typeof totalRecords === 'number' && totalRecords >= 0 ? totalRecords : dataT.length;
  const safeItemsPerPage =
    typeof itemsPerPage === 'number' && itemsPerPage > 0 ? itemsPerPage : Math.max(total, 1);
  const safeCurrentPage =
    typeof currentPage === 'number' && currentPage > 0 ? currentPage : 1;
  const totalPages = Math.ceil(total / safeItemsPerPage) || 1;
  const start = total === 0 ? 0 : (safeCurrentPage - 1) * safeItemsPerPage + 1;
  const end = Math.min(safeCurrentPage * safeItemsPerPage, total);
  const canGoPrevious = safeCurrentPage > 1 && typeof handlePreviousPage === 'function';
  const canGoNext = safeCurrentPage < totalPages && typeof handleNextPage === 'function';

  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 data-table-footer">
      <div className="small text-muted">
        Showing {start} to {end} of {total} entries
      </div>
      <div className="dataTables_paginate paging_simple_numbers" id="timetracker-table_paginate">
        <ul className="pagination mb-0">
          <li className={`paginate_button page-item previous ${!canGoPrevious ? 'disabled' : ''}`} id="timetracker-table_previous">
            <button onClick={handlePreviousPage} className="page-link" disabled={!canGoPrevious}>Previous</button>
          </li>
          <li className="paginate_button page-item active">
            <span className="page-link">{safeCurrentPage}</span>
          </li>
          <li className={`paginate_button page-item next ${!canGoNext ? 'disabled' : ''}`}>
            <button onClick={handleNextPage} className="page-link" disabled={!canGoNext}>Next</button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DataTableFooter;
